<!-->┌──────────────────────────────────────────────────────────────────────────────────────┐<- ->
<- ->│                                     Conflicts                                        │<- ->
<- ->└──────────────────────────────────────────────────────────────────────────────────────┘<--->

<template>
    <fieldset v-if="conflicts" class="conflict-errors">
        <legend>
            <span>Error</span>
            <button @click.stop="clearConflicts">Close</button>
        </legend>

        <template v-for="conflict in conflicts">
            <h3>{{ conflict.title }}</h3>
            <pre>{{ conflict.text }}</pre>
        </template>

    </fieldset>
</template>

<script>
    export let CONFLICTS = {
        data: _ => ({
            loading: false,
            saving: false,
            error: null,        //  Any my-problem error: service is responding but is returning an error
            exception: null,    //  Any not-my-problem error: service is not responding or is throwing an exception
            warning: null,      //  Any user-problem error
            isSysAdmin: false   //  true: user is a system administrator and is allowed to see more detailed information
        }),

        mounted() {
            if (this._TEST_PAGE_) this.isSysAdmin = true
        },

        computed: {
            _TEST_PAGE_: () => (location && location.pathname).includes('/dist/test-')
        },

        methods: {
            clearException() { this.exception = null },
            clearError() { this.error = this.exception = null },

            onThrow(data) {
                this.loading = false
                this.saving = false

                if (data) {
                    let error = data.error
                    let exception = data.exception

                    if (!error && !exception) {
                        if (data.constructor === Object)
                            error = data
                        else
                            error = {
                                title: "Javascript Error",
                                text: this.isSysAdmin ? data : ""
                            }
                    }

                    if (error) {
                        if (this.error) (this.error.conficts = this.error.conflicts || []).push(error)
                        else this.error = error
                    }

                    if (exception) {
                        if (this.exception) (this.exception.conficts = this.exception.conflicts || []).push(exception)
                        else this.exception = exception
                    }
                }
            }
        }
    }

    function recurse(field, tree, fn) {
        if (!tree || !field || !fn) return

        fn(tree)

        let children = tree[field]
        if (children)
            for (let child of children)
                recurse(field, child, fn)
    }

    export default {
        name: 'Conflicts',

        props: {
            "error": Object,
            "exception": Object,
            "isSysAdmin": Boolean
        },

        computed: {
            conflicts() {
                let conflicts = []

                recurse('conflicts', this.error,
                    conflict => conflicts.push({ type: 'error', ...conflict, conflicts: undefined })
                )

                recurse('conflicts', this.exception,
                    conflict => conflicts.push({ type: 'exception', ...conflict, conflicts: undefined })
                )

                if (!this.isSysAdmin)
                    conflicts = conflicts.filter(conflict => conflict.type != 'exception')

                return conflicts.length ? conflicts : null
            }
        },

        methods: {
            clearConflicts() {
                this.clearError()
                this.clearException()
            },

            clearError() { this.$emit("update:error", null) },
            clearException() { this.$emit("update:exception", null) }
        }
    }
</script>
